import { createContext, useContext } from "react";

const DEFAULT_LOCALE = "en-US";
const DEFAULT_CURRENCY_CODE = "USD";

type FormatContextFormatLocaleId = "us" | "iso" | "local";

export type FormatContextFormatLocaleOption = {
  id: FormatContextFormatLocaleId;
  locale: string;
  label: string;
};

export type FormatContextTimezoneOption = {
  id: string;
  code: string;
  label: string;
};

type FormatContextValue = {
  timezoneCode: string;
  timezoneLabel: string;
  timezoneId: string;
  timezoneOptions: FormatContextTimezoneOption[];
  selectTimezone: (optionId: string) => void;
  formatLocaleId: FormatContextFormatLocaleId;
  formatLocaleOptions: FormatContextFormatLocaleOption[];
  selectFormatLocale: (optionId: FormatContextFormatLocaleId) => void;
  locale: string;
  currencyCode: string;
};

export const formatContextDefaultValue: FormatContextValue = {
  timezoneCode: "UTC",
  timezoneLabel: "UTC",
  timezoneId: "utc",
  timezoneOptions: [],
  selectTimezone: () => {},
  formatLocaleId: "us",
  formatLocaleOptions: [],
  selectFormatLocale: () => {},
  locale: DEFAULT_LOCALE,
  currencyCode: DEFAULT_CURRENCY_CODE,
};

export const FormatContext = createContext<FormatContextValue>(formatContextDefaultValue);

export const useFormatContext = () => useContext(FormatContext);
